import { Icon, Tooltip } from 'antd';
import React from 'react';
import { getIconForStatus } from '../utils';

const passRateTooltipText =
    'This value indicates the percent of top 100 most visited websites in the US that pass this test (in the past 12 months). ' +
    'Failing a test that a high percentage of top websites are passing may indicate an industry best practice that you should be fixing.';

type Props = {
    title: string;
    status?: string;
    passRate?: number;
};

export default function SectionTitle({ title, status, passRate }: Props) {
    return (
        <div className="report-element-title">
            {status && (
                <>
                    <Icon
                        type={getIconForStatus(status)}
                        theme="filled"
                        className="status-icon"
                    />

                    <strong>{title}</strong>

                    {passRate && passRate > 0 ? (
                        <Tooltip title={passRateTooltipText}>
                            <small>{`${passRate}% of top 100 sites passed`}</small>
                        </Tooltip>
                    ) : null}
                </>
            )}

            {!status && (
                <>
                    <span className="status-icon default-icon" />
                    <strong>{title}</strong>
                </>
            )}
        </div>
    );
}
